import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'trueFalsePipe'})
export class TrueFalsePipe implements PipeTransform {
    transform(value: boolean): string {
        const icon = value ? '<i class="fa fa-check true-icon" title="True"></i>' : '<i class="fa fa-times false-icon" title="False"></i>';

        return `<div class="center-content">${icon}</div>`;
    }
}
